module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-4-green.svg";